import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPendingCommunication, fetchFinishedCommunication } from 'app/actions/CommunicationActions';
import IconButton from '@material-ui/core/IconButton';
import {
    getPendingCommunication,
    getIsLoadingPendingCommunication,
    getFinishedCommunication,
    getIsLoadingFinishedCommunication
} from '../../reducers/index';
import { Icon, Tooltip } from 'antd'
import moment from 'moment';
import isEmpty from 'app/utils/IsEmpty';
import TextEvents from 'app/components/TextEvents';


export default function CommunicationTableContainer(props) {

    const pagination = props.pagination;
    const sorter = props.sorter;
    let offset = 0;
    let limit = 0;
    let column = null;
    let order = null;

    const columns = [
        {
            title: 'Programa',
            dataIndex: 'communicationProgramName',
            key: 'communicationProgramName',
            sorter: true,
            width: 250,
            ellipsis: true
        },
        {
            title: 'Subdirección Origen',
            dataIndex: 'subdirectionName',
            key: 'subdirectionName',
            sorter: true,
            width: 250,
            ellipsis: true
        },
        {
            title: 'Procedimiento',
            dataIndex: 'courseName',
            width: 250,
            key: 'courseName',
            sorter: true,
            ellipsis: true
        },
        {
            title: 'Descripción',
            dataIndex: 'courseDescription',
            key: 'courseDescription',
            width: 250,
            sorter: true,
            ellipsis: true
        },
        {
            title: 'Tipo de Capacitación',
            dataIndex: 'typeTraining',
            key: 'typeTraining',
            sorter: true,
            width: 250,
        },
        {
            title: 'Especialidad/Sistema',
            dataIndex: 'specialtyName',
            key: 'specialtyName',
            sorter: true,
            width: 250,
        },
        {
            title: 'Version',
            dataIndex: 'courseVersion',
            key: 'courseVersion',
            sorter: true,
            width: 100,
        },
        {
            title: 'Vigencia',
            dataIndex: 'diffusionVigency',
            key: 'diffusionVigency',
            sorter: true,
            width: 150,
            render: (diffusionVigency) => {
                return moment(diffusionVigency).locale('es').format('L')
            }
        },
        {
            title: 'Estatus',
            dataIndex: 'statusColor',
            key: 'status',
            width: 100,
            sorter: true,
            render: (color, i) => {
                return <TextEvents
                    text={i.status}
                    size='13px'
                    weight="bold"
                    color="black"
                />
            }
        },
        {

        },
        {
            title: 'Acciones',
            key: 'action',
            dataIndex: 'communicationProgramName',
            fixed: 'right',
            width: 100,
            render: (id, i) => (
                <div>
                    <IconButton className={props.classes.editIcon} onClick={() => showTabEdit(id, i)}>
                        <Tooltip placement="bottomLeft" title={'Comunicar'}>
                            <Icon type="file-done" />
                        </Tooltip>
                    </IconButton>
                </div>
            ),
        },
    ];
    const columnsFinished = [
        {
            title: 'Programa',
            dataIndex: 'communicationProgramName',
            key: 'communicationProgramName',
            width: 300,
            ellipsis: true,
            sorter: true,
        },
        {
            title: 'Subdirección Origen',
            dataIndex: 'subdirectionName',
            key: 'subdirectionName',
            sorter: true,
            width: 250,
            ellipsis: true
        },
        {
            title: 'Procedimiento',
            dataIndex: 'courseName',
            sorter: true,
            key: 'courseName',
            width: 250,
            ellipsis: true
        },
        {
            title: 'Descripción',
            dataIndex: 'courseDescription',
            sorter: true,
            key: 'courseDescription',
            width: 350,
            ellipsis: true
        },
        {
            title: 'Tipo de Capacitación',
            dataIndex: 'typeTraining',
            key: 'typeTraining',
            sorter: true,
            width: 250,
            ellipsis: true
        },
        {
            title: 'Especialidad/Sistema',
            dataIndex: 'specialtyName',
            sorter: true,
            key: 'specialtyName',
            width: 250,
            ellipsis: true
        },
        {
            title: 'Version',
            dataIndex: 'courseVersion',
            sorter: true,
            key: 'courseVersion',
            width: 250,
            ellipsis: true
        },
        {
            title: 'Vigencia',
            dataIndex: 'diffusionVigency',
            sorter: true,
            key: 'diffusionVigency',
            width: 250,
            ellipsis: true,
            render: (diffusionVigency) => {
                return moment(diffusionVigency).locale('es').format('L')
            }
        },
        {
            title: 'Estatus',
            dataIndex: 'statusColor',
            key: 'status',
            width: 100,
            width: 250,
            ellipsis: true,
            render: (color, i) => {
                return <TextEvents
                    text={i.status}
                    size='13px'
                    weight="bold"
                    color="black"
                />
            }
        },
    ];

    const showTabEdit = (id, i) => {
        props.setVisible(true);
        props.setRow(i)
    }

    const pendingCommunication = useSelector(getPendingCommunication);
    const finishedCommunication = useSelector(getFinishedCommunication);
    const isLoading = useSelector(getIsLoadingPendingCommunication);

    const dispatch = useDispatch();
    useEffect(() => {
        if (isEmpty(pendingCommunication)) fetchTableData();

        if (isEmpty(finishedCommunication)) fetchFinishedData();

    }, []);

    // const handleTableChange = (pagination, filters, sorter) => {
    //     if(typeof sorter.column !== 'undefined'){
    //         const sortOrder= sorter.order==='ascend' ? 'ASC' : 'DESC';
    //         fetchTableData(props.userData.IdCompany, {sortColumn:sorter.columnKey, sortDir:sortOrder} )
    //     } else {
    //         setFilter()
    //         fetchTableData(props.userData.IdCompany)
    //     }
    // };
    const handleTableChange = (pagination, filters, sorter) => {
        props.setPagination(pagination);
        props.setSorter(sorter);
        if (Object.keys(sorter).length > 0) {
            column = sorter.field;
            order = sorter.order === "ascend" ? "ASC" : "DESC";
        }
        else {
            column = '';
            order = '';
        }
        dispatch(fetchPendingCommunication((props.userData.IdCompany == null ? props.userData.UserId : props.userData.IdCompany), {
            sortColumn: column,
            sortDir: order,
            offset: ((pagination.current - 1) * pagination.pageSize),
            limit: pagination.pageSize
        }))

    };
    const handleFinishedTableChange = (pagination, filters, sorter) => {
        props.setPagination(pagination);
        props.setSorter(sorter);
        if (Object.keys(sorter).length > 0) {
            column = sorter.field;
            order = sorter.order === "ascend" ? "ASC" : "DESC";
        }
        else {
            column = '';
            order = '';
        }
        dispatch(fetchFinishedCommunication((props.userData.IdCompany == null ? props.userData.UserId : props.userData.IdCompany), {
            sortColumn: column,
            sortDir: order,
            offset: ((pagination.current - 1) * pagination.pageSize),
            limit: pagination.pageSize
        }))

    };

    if (pagination != null) {
        offset = (0 * pagination.pageSize);
        limit = (pagination.pageSize);

        if (!isLoading && pendingCommunication.length > 0) {
            pagination.total = pendingCommunication[0].totalcount;
        }
        else {
            pagination.total = 0;
        }
    }

    if (sorter != null) {
        column = sorter.field;
        order = sorter.order === "ascend" ? "ASC" : "DESC";
    }

    const fetchTableData = (id, f) => dispatch(fetchPendingCommunication((props.userData.IdCompany == null ? props.userData.UserId : props.userData.IdCompany), f));
    const fetchFinishedData = (id, f) => dispatch(fetchFinishedCommunication((props.userData.IdCompany == null ? props.userData.UserId : props.userData.IdCompany), f));
    return (props.children({ isLoading, pendingCommunication, cols: columns, colsfinished: columnsFinished, handleFinishedTableChange, handleTableChange, finishedCommunication }));
}
